import { render, staticRenderFns } from "./pastRenewal.vue?vue&type=template&id=3f66bed2&scoped=true"
import script from "./pastRenewal.vue?vue&type=script&lang=js"
export * from "./pastRenewal.vue?vue&type=script&lang=js"
import style0 from "./pastRenewal.vue?vue&type=style&index=0&id=3f66bed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66bed2",
  null
  
)

export default component.exports